export const upComingStub = {
    "typeMatches": [
        {
            "matchType": "International",
            "seriesMatches": [
                {
                    "seriesAdWrapper": {
                        "seriesId": 7476,
                        "seriesName": "ICC Mens T20 World Cup 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 87745,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "36th Match, Group A",
                                    "matchFormat": "T20",
                                    "startDate": "1718548200000",
                                    "endDate": "1718560800000",
                                    "state": "Preview",
                                    "status": "Match starts at Jun 16, 14:30 GMT",
                                    "team1": {
                                        "teamId": 3,
                                        "teamName": "Pakistan",
                                        "teamSName": "PAK",
                                        "imageId": 172116
                                    },
                                    "team2": {
                                        "teamId": 27,
                                        "teamName": "Ireland",
                                        "teamSName": "IRE",
                                        "imageId": 495001
                                    },
                                    "venueInfo": {
                                        "id": 270,
                                        "ground": "Central Broward Regional Park Stadium Turf Ground",
                                        "city": "Lauderhill, Florida",
                                        "timezone": "-04:00",
                                        "latitude": "26.149670",
                                        "longitude": "-80.212196"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Preview"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87752,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "37th Match, Group D",
                                    "matchFormat": "T20",
                                    "startDate": "1718580600000",
                                    "endDate": "1718593200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 17, 23:30 GMT",
                                    "team1": {
                                        "teamId": 6,
                                        "teamName": "Bangladesh",
                                        "teamSName": "BAN",
                                        "imageId": 172120
                                    },
                                    "team2": {
                                        "teamId": 72,
                                        "teamName": "Nepal",
                                        "teamSName": "NEP",
                                        "imageId": 172169
                                    },
                                    "venueInfo": {
                                        "id": 58,
                                        "ground": "Arnos Vale Ground",
                                        "city": "Kingstown, St Vincent",
                                        "timezone": "-04:00",
                                        "latitude": "13.141873",
                                        "longitude": "-61.211811"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87759,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "38th Match, Group D",
                                    "matchFormat": "T20",
                                    "startDate": "1718584200000",
                                    "endDate": "1718596800000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 17, 00:30 GMT",
                                    "team1": {
                                        "teamId": 5,
                                        "teamName": "Sri Lanka",
                                        "teamSName": "SL",
                                        "imageId": 172119
                                    },
                                    "team2": {
                                        "teamId": 24,
                                        "teamName": "Netherlands",
                                        "teamSName": "NED",
                                        "imageId": 172138
                                    },
                                    "venueInfo": {
                                        "id": 59,
                                        "ground": "Daren Sammy National Cricket Stadium",
                                        "city": "Gros Islet, St Lucia",
                                        "timezone": "-04:00",
                                        "latitude": "14.070532",
                                        "longitude": "-60.931743"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87766,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "39th Match, Group C",
                                    "matchFormat": "T20",
                                    "startDate": "1718634600000",
                                    "endDate": "1718647200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 17, 14:30 GMT",
                                    "team1": {
                                        "teamId": 13,
                                        "teamName": "New Zealand",
                                        "teamSName": "NZ",
                                        "imageId": 172128
                                    },
                                    "team2": {
                                        "teamId": 287,
                                        "teamName": "Papua New Guinea",
                                        "teamSName": "PNG",
                                        "imageId": 172336
                                    },
                                    "venueInfo": {
                                        "id": 500,
                                        "ground": "Brian Lara Stadium",
                                        "city": "Tarouba, Trinidad",
                                        "timezone": "-04:00",
                                        "latitude": "10.295034",
                                        "longitude": "-61.445609"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87773,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "40th Match, Group C",
                                    "matchFormat": "T20",
                                    "startDate": "1718670600000",
                                    "endDate": "1718683200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 18, 00:30 GMT",
                                    "team1": {
                                        "teamId": 10,
                                        "teamName": "West Indies",
                                        "teamSName": "WI",
                                        "imageId": 172124
                                    },
                                    "team2": {
                                        "teamId": 96,
                                        "teamName": "Afghanistan",
                                        "teamSName": "AFG",
                                        "imageId": 172188
                                    },
                                    "venueInfo": {
                                        "id": 59,
                                        "ground": "Daren Sammy National Cricket Stadium",
                                        "city": "Gros Islet, St Lucia",
                                        "timezone": "-04:00",
                                        "latitude": "14.070532",
                                        "longitude": "-60.931743"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87780,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "Super 8 Group 2",
                                    "matchFormat": "T20",
                                    "startDate": "1718807400000",
                                    "endDate": "1718820000000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 19, 14:30 GMT",
                                    "team1": {
                                        "teamId": 15,
                                        "teamName": "United States",
                                        "teamSName": "USA",
                                        "imageId": 172130
                                    },
                                    "team2": {
                                        "teamId": 11,
                                        "teamName": "South Africa",
                                        "teamSName": "RSA",
                                        "imageId": 172126
                                    },
                                    "venueInfo": {
                                        "id": 109,
                                        "ground": "Sir Vivian Richards Stadium",
                                        "city": "North Sound, Antigua",
                                        "timezone": "-04:00",
                                        "latitude": "17.103332",
                                        "longitude": "-61.784959"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87787,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "Super 8 Group 2",
                                    "matchFormat": "T20",
                                    "startDate": "1718843400000",
                                    "endDate": "1718856000000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 20, 00:30 GMT",
                                    "team1": {
                                        "teamId": 30,
                                        "teamName": "B1",
                                        "teamSName": "B1",
                                        "imageId": 174284
                                    },
                                    "team2": {
                                        "teamId": 10,
                                        "teamName": "West Indies",
                                        "teamSName": "WI",
                                        "imageId": 172124
                                    },
                                    "venueInfo": {
                                        "id": 59,
                                        "ground": "Daren Sammy National Cricket Stadium",
                                        "city": "Gros Islet, St Lucia",
                                        "timezone": "-04:00",
                                        "latitude": "14.070532",
                                        "longitude": "-60.931743"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87794,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "Super 8 Group 1",
                                    "matchFormat": "T20",
                                    "startDate": "1718893800000",
                                    "endDate": "1718906400000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 20, 14:30 GMT",
                                    "team1": {
                                        "teamId": 96,
                                        "teamName": "Afghanistan",
                                        "teamSName": "AFG",
                                        "imageId": 172188
                                    },
                                    "team2": {
                                        "teamId": 2,
                                        "teamName": "India",
                                        "teamSName": "IND",
                                        "imageId": 172115
                                    },
                                    "venueInfo": {
                                        "id": 55,
                                        "ground": "Kensington Oval",
                                        "city": "Bridgetown, Barbados",
                                        "timezone": "-04:00",
                                        "latitude": "13.105021",
                                        "longitude": "-59.62257"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87801,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "Super 8 Group 1",
                                    "matchFormat": "T20",
                                    "startDate": "1718929800000",
                                    "endDate": "1718942400000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 21, 00:30 GMT",
                                    "team1": {
                                        "teamId": 4,
                                        "teamName": "Australia",
                                        "teamSName": "AUS",
                                        "imageId": 172117
                                    },
                                    "team2": {
                                        "teamId": 35,
                                        "teamName": "D2",
                                        "teamSName": "D2",
                                        "imageId": 174284
                                    },
                                    "venueInfo": {
                                        "id": 109,
                                        "ground": "Sir Vivian Richards Stadium",
                                        "city": "North Sound, Antigua",
                                        "timezone": "-04:00",
                                        "latitude": "17.103332",
                                        "longitude": "-61.784959"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87808,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "Super 8 Group 2",
                                    "matchFormat": "T20",
                                    "startDate": "1718980200000",
                                    "endDate": "1718992800000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 21, 14:30 GMT",
                                    "team1": {
                                        "teamId": 30,
                                        "teamName": "B1",
                                        "teamSName": "B1",
                                        "imageId": 174284
                                    },
                                    "team2": {
                                        "teamId": 11,
                                        "teamName": "South Africa",
                                        "teamSName": "RSA",
                                        "imageId": 172126
                                    },
                                    "venueInfo": {
                                        "id": 59,
                                        "ground": "Daren Sammy National Cricket Stadium",
                                        "city": "Gros Islet, St Lucia",
                                        "timezone": "-04:00",
                                        "latitude": "14.070532",
                                        "longitude": "-60.931743"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87815,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "Super 8 Group 2",
                                    "matchFormat": "T20",
                                    "startDate": "1719016200000",
                                    "endDate": "1719028800000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 22, 00:30 GMT",
                                    "team1": {
                                        "teamId": 15,
                                        "teamName": "United States",
                                        "teamSName": "USA",
                                        "imageId": 172130
                                    },
                                    "team2": {
                                        "teamId": 10,
                                        "teamName": "West Indies",
                                        "teamSName": "WI",
                                        "imageId": 172124
                                    },
                                    "venueInfo": {
                                        "id": 55,
                                        "ground": "Kensington Oval",
                                        "city": "Bridgetown, Barbados",
                                        "timezone": "-04:00",
                                        "latitude": "13.105021",
                                        "longitude": "-59.62257"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87822,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "Super 8 Group 1",
                                    "matchFormat": "T20",
                                    "startDate": "1719066600000",
                                    "endDate": "1719079200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 22, 14:30 GMT",
                                    "team1": {
                                        "teamId": 2,
                                        "teamName": "India",
                                        "teamSName": "IND",
                                        "imageId": 172115
                                    },
                                    "team2": {
                                        "teamId": 35,
                                        "teamName": "D2",
                                        "teamSName": "D2",
                                        "imageId": 174284
                                    },
                                    "venueInfo": {
                                        "id": 109,
                                        "ground": "Sir Vivian Richards Stadium",
                                        "city": "North Sound, Antigua",
                                        "timezone": "-04:00",
                                        "latitude": "17.103332",
                                        "longitude": "-61.784959"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 87829,
                                    "seriesId": 7476,
                                    "seriesName": "ICC Mens T20 World Cup 2024",
                                    "matchDesc": "Super 8 Group 1",
                                    "matchFormat": "T20",
                                    "startDate": "1719102600000",
                                    "endDate": "1719115200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 23, 00:30 GMT",
                                    "team1": {
                                        "teamId": 96,
                                        "teamName": "Afghanistan",
                                        "teamSName": "AFG",
                                        "imageId": 172188
                                    },
                                    "team2": {
                                        "teamId": 4,
                                        "teamName": "Australia",
                                        "teamSName": "AUS",
                                        "imageId": 172117
                                    },
                                    "venueInfo": {
                                        "id": 58,
                                        "ground": "Arnos Vale Ground",
                                        "city": "Kingstown, St Vincent",
                                        "timezone": "-04:00",
                                        "latitude": "13.141873",
                                        "longitude": "-61.211811"
                                    },
                                    "seriesStartDt": "1717200000000",
                                    "seriesEndDt": "1719792000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            }
                        ]
                    }
                },
                {
                    "adDetail": {
                        "name": "native_matches",
                        "layout": "native_large",
                        "position": 1
                    }
                },
                {
                    "seriesAdWrapper": {
                        "seriesId": 8260,
                        "seriesName": "Jersey tour of Denmark, 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96910,
                                    "seriesId": 8260,
                                    "seriesName": "Jersey tour of Denmark, 2024",
                                    "matchDesc": "2nd T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718526600000",
                                    "endDate": "1718539200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 16, 08:30 GMT",
                                    "team1": {
                                        "teamId": 185,
                                        "teamName": "Denmark",
                                        "teamSName": "DEN",
                                        "imageId": 172245
                                    },
                                    "team2": {
                                        "teamId": 303,
                                        "teamName": "Jersey",
                                        "teamSName": "JER",
                                        "imageId": 172352
                                    },
                                    "venueInfo": {
                                        "id": 570,
                                        "ground": "Svanholm Park",
                                        "city": "Brondby",
                                        "timezone": "+02:00",
                                        "latitude": "55.653890",
                                        "longitude": "12.425710"
                                    },
                                    "seriesStartDt": "1718409600000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96917,
                                    "seriesId": 8260,
                                    "seriesName": "Jersey tour of Denmark, 2024",
                                    "matchDesc": "3rd T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718542800000",
                                    "endDate": "1718555400000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 16, 13:00 GMT",
                                    "team1": {
                                        "teamId": 185,
                                        "teamName": "Denmark",
                                        "teamSName": "DEN",
                                        "imageId": 172245
                                    },
                                    "team2": {
                                        "teamId": 303,
                                        "teamName": "Jersey",
                                        "teamSName": "JER",
                                        "imageId": 172352
                                    },
                                    "venueInfo": {
                                        "id": 570,
                                        "ground": "Svanholm Park",
                                        "city": "Brondby",
                                        "timezone": "+02:00",
                                        "latitude": "55.653890",
                                        "longitude": "12.425710"
                                    },
                                    "seriesStartDt": "1718409600000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            }
                        ]
                    }
                },
                {
                    "seriesAdWrapper": {
                        "seriesId": 8310,
                        "seriesName": "Estonia tour of Cyprus 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96744,
                                    "seriesId": 8310,
                                    "seriesName": "Estonia tour of Cyprus 2024",
                                    "matchDesc": "1st T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718602200000",
                                    "endDate": "1718614800000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 17, 05:30 GMT",
                                    "team1": {
                                        "teamId": 1111,
                                        "teamName": "Cyprus",
                                        "teamSName": "CYP",
                                        "imageId": 247198
                                    },
                                    "team2": {
                                        "teamId": 526,
                                        "teamName": "Estonia",
                                        "teamSName": "EST",
                                        "imageId": 172576
                                    },
                                    "venueInfo": {
                                        "id": 1893,
                                        "ground": "Happy Valley Ground",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96748,
                                    "seriesId": 8310,
                                    "seriesName": "Estonia tour of Cyprus 2024",
                                    "matchDesc": "2nd T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718615700000",
                                    "endDate": "1718628300000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 17, 09:15 GMT",
                                    "team1": {
                                        "teamId": 1111,
                                        "teamName": "Cyprus",
                                        "teamSName": "CYP",
                                        "imageId": 247198
                                    },
                                    "team2": {
                                        "teamId": 526,
                                        "teamName": "Estonia",
                                        "teamSName": "EST",
                                        "imageId": 172576
                                    },
                                    "venueInfo": {
                                        "id": 1893,
                                        "ground": "Happy Valley Ground",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96757,
                                    "seriesId": 8310,
                                    "seriesName": "Estonia tour of Cyprus 2024",
                                    "matchDesc": "3rd T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718688600000",
                                    "endDate": "1718701200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 18, 05:30 GMT",
                                    "team1": {
                                        "teamId": 1111,
                                        "teamName": "Cyprus",
                                        "teamSName": "CYP",
                                        "imageId": 247198
                                    },
                                    "team2": {
                                        "teamId": 526,
                                        "teamName": "Estonia",
                                        "teamSName": "EST",
                                        "imageId": 172576
                                    },
                                    "venueInfo": {
                                        "id": 1893,
                                        "ground": "Happy Valley Ground",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96762,
                                    "seriesId": 8310,
                                    "seriesName": "Estonia tour of Cyprus 2024",
                                    "matchDesc": "4th T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718702100000",
                                    "endDate": "1718714700000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 18, 09:15 GMT",
                                    "team1": {
                                        "teamId": 1111,
                                        "teamName": "Cyprus",
                                        "teamSName": "CYP",
                                        "imageId": 247198
                                    },
                                    "team2": {
                                        "teamId": 526,
                                        "teamName": "Estonia",
                                        "teamSName": "EST",
                                        "imageId": 172576
                                    },
                                    "venueInfo": {
                                        "id": 1893,
                                        "ground": "Happy Valley Ground",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96766,
                                    "seriesId": 8310,
                                    "seriesName": "Estonia tour of Cyprus 2024",
                                    "matchDesc": "5th T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718775000000",
                                    "endDate": "1718787600000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 19, 05:30 GMT",
                                    "team1": {
                                        "teamId": 1111,
                                        "teamName": "Cyprus",
                                        "teamSName": "CYP",
                                        "imageId": 247198
                                    },
                                    "team2": {
                                        "teamId": 526,
                                        "teamName": "Estonia",
                                        "teamSName": "EST",
                                        "imageId": 172576
                                    },
                                    "venueInfo": {
                                        "id": 1893,
                                        "ground": "Happy Valley Ground",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96771,
                                    "seriesId": 8310,
                                    "seriesName": "Estonia tour of Cyprus 2024",
                                    "matchDesc": "6th T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718788500000",
                                    "endDate": "1718801100000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 19, 09:15 GMT",
                                    "team1": {
                                        "teamId": 1111,
                                        "teamName": "Cyprus",
                                        "teamSName": "CYP",
                                        "imageId": 247198
                                    },
                                    "team2": {
                                        "teamId": 526,
                                        "teamName": "Estonia",
                                        "teamSName": "EST",
                                        "imageId": 172576
                                    },
                                    "venueInfo": {
                                        "id": 1893,
                                        "ground": "Happy Valley Ground",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            }
                        ]
                    }
                },
                {
                    "seriesAdWrapper": {
                        "seriesId": 8256,
                        "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96438,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "3rd Place Play-off",
                                    "matchFormat": "T20",
                                    "startDate": "1718525700000",
                                    "endDate": "1718538300000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 16, 08:15 GMT",
                                    "team1": {
                                        "teamId": 106,
                                        "teamName": "TBC",
                                        "teamSName": "TBC",
                                        "imageId": 172198
                                    },
                                    "team2": {
                                        "teamId": 106,
                                        "teamName": "TBC",
                                        "teamSName": "TBC",
                                        "imageId": 172198
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96442,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "7th Place Play-off",
                                    "matchFormat": "T20",
                                    "startDate": "1718525700000",
                                    "endDate": "1718538300000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 16, 08:15 GMT",
                                    "team1": {
                                        "teamId": 106,
                                        "teamName": "TBC",
                                        "teamSName": "TBC",
                                        "imageId": 172198
                                    },
                                    "team2": {
                                        "teamId": 106,
                                        "teamName": "TBC",
                                        "teamSName": "TBC",
                                        "imageId": 172198
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96451,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "5th Place Play-off",
                                    "matchFormat": "T20",
                                    "startDate": "1718543700000",
                                    "endDate": "1718556300000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 16, 13:15 GMT",
                                    "team1": {
                                        "teamId": 106,
                                        "teamName": "TBC",
                                        "teamSName": "TBC",
                                        "imageId": 172198
                                    },
                                    "team2": {
                                        "teamId": 106,
                                        "teamName": "TBC",
                                        "teamSName": "TBC",
                                        "imageId": 172198
                                    },
                                    "venueInfo": {
                                        "id": 1942,
                                        "ground": "Simar Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96456,
                                    "seriesId": 8256,
                                    "seriesName": "ICC Mens T20 World Cup Europe Qualifier A, 2024",
                                    "matchDesc": "Final",
                                    "matchFormat": "T20",
                                    "startDate": "1718543700000",
                                    "endDate": "1718556300000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 16, 13:15 GMT",
                                    "team1": {
                                        "teamId": 106,
                                        "teamName": "TBC",
                                        "teamSName": "TBC",
                                        "imageId": 172198
                                    },
                                    "team2": {
                                        "teamId": 106,
                                        "teamName": "TBC",
                                        "teamSName": "TBC",
                                        "imageId": 172198
                                    },
                                    "venueInfo": {
                                        "id": 1475,
                                        "ground": "Roma Cricket Ground",
                                        "city": "Rome",
                                        "timezone": "+02:00",
                                        "latitude": "17.31922",
                                        "longitude": "78.31205"
                                    },
                                    "seriesStartDt": "1717891200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        {
            "matchType": "League",
            "seriesMatches": [
                {
                    "seriesAdWrapper": {
                        "seriesId": 7336,
                        "seriesName": "T20 Blast 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 84700,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718544600000",
                                    "endDate": "1718557200000",
                                    "state": "Preview",
                                    "status": "Match starts at Jun 16, 13:30 GMT",
                                    "team1": {
                                        "teamId": 141,
                                        "teamName": "Durham",
                                        "teamSName": "DUR",
                                        "imageId": 172208
                                    },
                                    "team2": {
                                        "teamId": 143,
                                        "teamName": "Lancashire",
                                        "teamSName": "LANCS",
                                        "imageId": 172210
                                    },
                                    "venueInfo": {
                                        "id": 60,
                                        "ground": "Riverside Ground",
                                        "city": "Chester-le-Street",
                                        "timezone": "+01:00",
                                        "latitude": "54.849531",
                                        "longitude": "-1.56103"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Preview"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84707,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718544600000",
                                    "endDate": "1718557200000",
                                    "state": "Preview",
                                    "status": "Match starts at Jun 16, 13:30 GMT",
                                    "team1": {
                                        "teamId": 147,
                                        "teamName": "Worcestershire",
                                        "teamSName": "WORCS",
                                        "imageId": 172214
                                    },
                                    "team2": {
                                        "teamId": 142,
                                        "teamName": "Northamptonshire",
                                        "teamSName": "NHNTS",
                                        "imageId": 172209
                                    },
                                    "venueInfo": {
                                        "id": 225,
                                        "ground": "New Road",
                                        "city": "Worcester",
                                        "timezone": "+01:00",
                                        "latitude": "52.189294",
                                        "longitude": "-2.2268"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Preview"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84686,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718546400000",
                                    "endDate": "1718559000000",
                                    "state": "Preview",
                                    "status": "Match starts at Jun 16, 14:00 GMT",
                                    "team1": {
                                        "teamId": 119,
                                        "teamName": "Somerset",
                                        "teamSName": "SOM",
                                        "imageId": 172199
                                    },
                                    "team2": {
                                        "teamId": 149,
                                        "teamName": "Glamorgan",
                                        "teamSName": "GLAM",
                                        "imageId": 172216
                                    },
                                    "venueInfo": {
                                        "id": 223,
                                        "ground": "The Cooper Associates County Ground",
                                        "city": "Taunton",
                                        "timezone": "+01:00",
                                        "latitude": "51.018913",
                                        "longitude": "3.100894"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Preview"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84721,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718546400000",
                                    "endDate": "1718559000000",
                                    "state": "Preview",
                                    "status": "Match starts at Jun 16, 14:00 GMT",
                                    "team1": {
                                        "teamId": 146,
                                        "teamName": "Yorkshire",
                                        "teamSName": "YORKS",
                                        "imageId": 172213
                                    },
                                    "team2": {
                                        "teamId": 145,
                                        "teamName": "Leicestershire",
                                        "teamSName": "LEIC",
                                        "imageId": 172212
                                    },
                                    "venueInfo": {
                                        "id": 66,
                                        "ground": "Headingley",
                                        "city": "Leeds",
                                        "timezone": "+01:00",
                                        "latitude": "53.817622",
                                        "longitude": "-1.58211"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Preview"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84693,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718548200000",
                                    "endDate": "1718560800000",
                                    "state": "Preview",
                                    "status": "Match starts at Jun 16, 13:30 GMT",
                                    "team1": {
                                        "teamId": 150,
                                        "teamName": "Kent",
                                        "teamSName": "KENT",
                                        "imageId": 172217
                                    },
                                    "team2": {
                                        "teamId": 151,
                                        "teamName": "Gloucestershire",
                                        "teamSName": "GLOUCS",
                                        "imageId": 172218
                                    },
                                    "venueInfo": {
                                        "id": 67,
                                        "ground": "St Lawrence Ground",
                                        "city": "Canterbury",
                                        "timezone": "+01:00",
                                        "latitude": "51.267447",
                                        "longitude": "1.091621"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Preview"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84714,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718550000000",
                                    "endDate": "1718562600000",
                                    "state": "Preview",
                                    "status": "Match starts at Jun 16, 15:00 GMT",
                                    "team1": {
                                        "teamId": 144,
                                        "teamName": "Derbyshire",
                                        "teamSName": "DERBY",
                                        "imageId": 172211
                                    },
                                    "team2": {
                                        "teamId": 140,
                                        "teamName": "Warwickshire",
                                        "teamSName": "WARKS",
                                        "imageId": 172207
                                    },
                                    "venueInfo": {
                                        "id": 226,
                                        "ground": "County Ground",
                                        "city": "Derby",
                                        "timezone": "+01:00",
                                        "latitude": "52.927517",
                                        "longitude": "-1.461188"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Preview"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84728,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718903700000",
                                    "endDate": "1718916300000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 20, 17:15 GMT",
                                    "team1": {
                                        "teamId": 74,
                                        "teamName": "Middlesex",
                                        "teamSName": "MDX",
                                        "imageId": 172170
                                    },
                                    "team2": {
                                        "teamId": 148,
                                        "teamName": "Surrey",
                                        "teamSName": "SUR",
                                        "imageId": 172215
                                    },
                                    "venueInfo": {
                                        "id": 19,
                                        "ground": "Lord's",
                                        "city": "London",
                                        "timezone": "+01:00",
                                        "latitude": "51.529488",
                                        "longitude": "-0.172926"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84735,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718904600000",
                                    "endDate": "1718917200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 20, 17:30 GMT",
                                    "team1": {
                                        "teamId": 146,
                                        "teamName": "Yorkshire",
                                        "teamSName": "YORKS",
                                        "imageId": 172213
                                    },
                                    "team2": {
                                        "teamId": 143,
                                        "teamName": "Lancashire",
                                        "teamSName": "LANCS",
                                        "imageId": 172210
                                    },
                                    "venueInfo": {
                                        "id": 66,
                                        "ground": "Headingley",
                                        "city": "Leeds",
                                        "timezone": "+01:00",
                                        "latitude": "53.817622",
                                        "longitude": "-1.58211"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84742,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718904600000",
                                    "endDate": "1718917200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 20, 17:30 GMT",
                                    "team1": {
                                        "teamId": 149,
                                        "teamName": "Glamorgan",
                                        "teamSName": "GLAM",
                                        "imageId": 172216
                                    },
                                    "team2": {
                                        "teamId": 151,
                                        "teamName": "Gloucestershire",
                                        "teamSName": "GLOUCS",
                                        "imageId": 172218
                                    },
                                    "venueInfo": {
                                        "id": 62,
                                        "ground": "Sophia Gardens",
                                        "city": "Cardiff",
                                        "timezone": "+01:00",
                                        "latitude": "51.484257",
                                        "longitude": "-3.189187"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84749,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718904600000",
                                    "endDate": "1718917200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 20, 17:30 GMT",
                                    "team1": {
                                        "teamId": 140,
                                        "teamName": "Warwickshire",
                                        "teamSName": "WARKS",
                                        "imageId": 172207
                                    },
                                    "team2": {
                                        "teamId": 142,
                                        "teamName": "Northamptonshire",
                                        "teamSName": "NHNTS",
                                        "imageId": 172209
                                    },
                                    "venueInfo": {
                                        "id": 20,
                                        "ground": "Edgbaston",
                                        "city": "Birmingham",
                                        "timezone": "+01:00",
                                        "latitude": "52.455774",
                                        "longitude": "-1.902624"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84756,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718906400000",
                                    "endDate": "1718919000000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 20, 18:00 GMT",
                                    "team1": {
                                        "teamId": 152,
                                        "teamName": "Essex",
                                        "teamSName": "ESS",
                                        "imageId": 172219
                                    },
                                    "team2": {
                                        "teamId": 153,
                                        "teamName": "Hampshire",
                                        "teamSName": "HAM",
                                        "imageId": 172220
                                    },
                                    "venueInfo": {
                                        "id": 118,
                                        "ground": "County Ground",
                                        "city": "Chelmsford",
                                        "timezone": "+01:00",
                                        "latitude": "51.731580",
                                        "longitude": "0.469004"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84763,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718906400000",
                                    "endDate": "1718919000000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 20, 18:00 GMT",
                                    "team1": {
                                        "teamId": 41,
                                        "teamName": "Sussex",
                                        "teamSName": "SUS",
                                        "imageId": 172148
                                    },
                                    "team2": {
                                        "teamId": 150,
                                        "teamName": "Kent",
                                        "teamSName": "KENT",
                                        "imageId": 172217
                                    },
                                    "venueInfo": {
                                        "id": 292,
                                        "ground": "County Ground",
                                        "city": "Hove",
                                        "timezone": "+01:00",
                                        "latitude": "50.830995",
                                        "longitude": "-0.163522"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84770,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718987400000",
                                    "endDate": "1719000000000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 21, 16:30 GMT",
                                    "team1": {
                                        "teamId": 147,
                                        "teamName": "Worcestershire",
                                        "teamSName": "WORCS",
                                        "imageId": 172214
                                    },
                                    "team2": {
                                        "teamId": 140,
                                        "teamName": "Warwickshire",
                                        "teamSName": "WARKS",
                                        "imageId": 172207
                                    },
                                    "venueInfo": {
                                        "id": 225,
                                        "ground": "New Road",
                                        "city": "Worcester",
                                        "timezone": "+01:00",
                                        "latitude": "52.189294",
                                        "longitude": "-2.2268"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84777,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718991000000",
                                    "endDate": "1719003600000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 21, 17:30 GMT",
                                    "team1": {
                                        "teamId": 141,
                                        "teamName": "Durham",
                                        "teamSName": "DUR",
                                        "imageId": 172208
                                    },
                                    "team2": {
                                        "teamId": 146,
                                        "teamName": "Yorkshire",
                                        "teamSName": "YORKS",
                                        "imageId": 172213
                                    },
                                    "venueInfo": {
                                        "id": 60,
                                        "ground": "Riverside Ground",
                                        "city": "Chester-le-Street",
                                        "timezone": "+01:00",
                                        "latitude": "54.849531",
                                        "longitude": "-1.56103"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84784,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718991000000",
                                    "endDate": "1719003600000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 21, 17:30 GMT",
                                    "team1": {
                                        "teamId": 151,
                                        "teamName": "Gloucestershire",
                                        "teamSName": "GLOUCS",
                                        "imageId": 172218
                                    },
                                    "team2": {
                                        "teamId": 119,
                                        "teamName": "Somerset",
                                        "teamSName": "SOM",
                                        "imageId": 172199
                                    },
                                    "venueInfo": {
                                        "id": 63,
                                        "ground": "County Ground",
                                        "city": "Bristol",
                                        "timezone": "+01:00",
                                        "latitude": "51.477246",
                                        "longitude": "-2.584212"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84791,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718991000000",
                                    "endDate": "1719003600000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 21, 17:30 GMT",
                                    "team1": {
                                        "teamId": 150,
                                        "teamName": "Kent",
                                        "teamSName": "KENT",
                                        "imageId": 172217
                                    },
                                    "team2": {
                                        "teamId": 152,
                                        "teamName": "Essex",
                                        "teamSName": "ESS",
                                        "imageId": 172219
                                    },
                                    "venueInfo": {
                                        "id": 67,
                                        "ground": "St Lawrence Ground",
                                        "city": "Canterbury",
                                        "timezone": "+01:00",
                                        "latitude": "51.267447",
                                        "longitude": "1.091621"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84798,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718991000000",
                                    "endDate": "1719003600000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 21, 17:30 GMT",
                                    "team1": {
                                        "teamId": 148,
                                        "teamName": "Surrey",
                                        "teamSName": "SUR",
                                        "imageId": 172215
                                    },
                                    "team2": {
                                        "teamId": 149,
                                        "teamName": "Glamorgan",
                                        "teamSName": "GLAM",
                                        "imageId": 172216
                                    },
                                    "venueInfo": {
                                        "id": 12,
                                        "ground": "Kennington Oval",
                                        "city": "London",
                                        "timezone": "+01:00",
                                        "latitude": "51.48368",
                                        "longitude": "-0.114885"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84805,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718991000000",
                                    "endDate": "1719003600000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 21, 17:30 GMT",
                                    "team1": {
                                        "teamId": 139,
                                        "teamName": "Nottinghamshire",
                                        "teamSName": "NOTTS",
                                        "imageId": 172206
                                    },
                                    "team2": {
                                        "teamId": 144,
                                        "teamName": "Derbyshire",
                                        "teamSName": "DERBY",
                                        "imageId": 172211
                                    },
                                    "venueInfo": {
                                        "id": 18,
                                        "ground": "Trent Bridge",
                                        "city": "Nottingham",
                                        "timezone": "+01:00",
                                        "latitude": "52.936884",
                                        "longitude": "-1.132230"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84812,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "North Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718991000000",
                                    "endDate": "1719003600000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 21, 17:30 GMT",
                                    "team1": {
                                        "teamId": 142,
                                        "teamName": "Northamptonshire",
                                        "teamSName": "NHNTS",
                                        "imageId": 172209
                                    },
                                    "team2": {
                                        "teamId": 145,
                                        "teamName": "Leicestershire",
                                        "teamSName": "LEIC",
                                        "imageId": 172212
                                    },
                                    "venueInfo": {
                                        "id": 119,
                                        "ground": "County Ground",
                                        "city": "Northampton",
                                        "timezone": "+01:00",
                                        "latitude": "52.248160",
                                        "longitude": "-0.871060"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 84819,
                                    "seriesId": 7336,
                                    "seriesName": "T20 Blast 2024",
                                    "matchDesc": "South Group",
                                    "matchFormat": "T20",
                                    "startDate": "1718992800000",
                                    "endDate": "1719005400000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 21, 18:00 GMT",
                                    "team1": {
                                        "teamId": 153,
                                        "teamName": "Hampshire",
                                        "teamSName": "HAM",
                                        "imageId": 172220
                                    },
                                    "team2": {
                                        "teamId": 41,
                                        "teamName": "Sussex",
                                        "teamSName": "SUS",
                                        "imageId": 172148
                                    },
                                    "venueInfo": {
                                        "id": 21,
                                        "ground": "The Rose Bowl",
                                        "city": "Southampton",
                                        "timezone": "+01:00",
                                        "latitude": "50.924131",
                                        "longitude": "-1.322163"
                                    },
                                    "seriesStartDt": "1717027200000",
                                    "seriesEndDt": "1726444800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            }
                        ]
                    }
                }
            ]
        },
        {
            "matchType": "Women",
            "seriesMatches": [
                {
                    "seriesAdWrapper": {
                        "seriesId": 8069,
                        "seriesName": "South Africa Women tour of India, 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 94487,
                                    "seriesId": 8069,
                                    "seriesName": "South Africa Women tour of India, 2024",
                                    "matchDesc": "1st ODI (ICC Championship Match)",
                                    "matchFormat": "ODI",
                                    "startDate": "1718524800000",
                                    "endDate": "1718553600000",
                                    "state": "Preview",
                                    "status": "Match starts at Jun 16, 08:00 GMT",
                                    "team1": {
                                        "teamId": 97,
                                        "teamName": "India Women",
                                        "teamSName": "INDW",
                                        "imageId": 172189
                                    },
                                    "team2": {
                                        "teamId": 260,
                                        "teamName": "South Africa Women",
                                        "teamSName": "RSAW",
                                        "imageId": 172313
                                    },
                                    "venueInfo": {
                                        "id": 27,
                                        "ground": "M.Chinnaswamy Stadium",
                                        "city": "Bengaluru",
                                        "timezone": "+05:30",
                                        "latitude": "12.978853",
                                        "longitude": "77.599533"
                                    },
                                    "seriesStartDt": "1718496000000",
                                    "seriesEndDt": "1720656000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Preview"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 94496,
                                    "seriesId": 8069,
                                    "seriesName": "South Africa Women tour of India, 2024",
                                    "matchDesc": "2nd ODI (ICC Championship Match)",
                                    "matchFormat": "ODI",
                                    "startDate": "1718784000000",
                                    "endDate": "1718812800000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 19, 08:00 GMT",
                                    "team1": {
                                        "teamId": 97,
                                        "teamName": "India Women",
                                        "teamSName": "INDW",
                                        "imageId": 172189
                                    },
                                    "team2": {
                                        "teamId": 260,
                                        "teamName": "South Africa Women",
                                        "teamSName": "RSAW",
                                        "imageId": 172313
                                    },
                                    "venueInfo": {
                                        "id": 27,
                                        "ground": "M.Chinnaswamy Stadium",
                                        "city": "Bengaluru",
                                        "timezone": "+05:30",
                                        "latitude": "12.978853",
                                        "longitude": "77.599533"
                                    },
                                    "seriesStartDt": "1718496000000",
                                    "seriesEndDt": "1720656000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            }
                        ]
                    }
                },
                {
                    "seriesAdWrapper": {
                        "seriesId": 8323,
                        "seriesName": "Women Central Europe Cup, 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96953,
                                    "seriesId": 8323,
                                    "seriesName": "Women Central Europe Cup, 2024",
                                    "matchDesc": "5th Match",
                                    "matchFormat": "T20",
                                    "startDate": "1718524800000",
                                    "endDate": "1718537400000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 16, 08:00 GMT",
                                    "team1": {
                                        "teamId": 1994,
                                        "teamName": "Croatia Women",
                                        "teamSName": "CRTW",
                                        "imageId": 501076
                                    },
                                    "team2": {
                                        "teamId": 1507,
                                        "teamName": "Gibraltar Women",
                                        "teamSName": "GIBW",
                                        "imageId": 297980
                                    },
                                    "venueInfo": {
                                        "id": 941,
                                        "ground": "Scott Page Field, Vinor",
                                        "city": "Prague",
                                        "timezone": "+02:00",
                                        "latitude": "50.0755",
                                        "longitude": "14.4378"
                                    },
                                    "seriesStartDt": "1718323200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96962,
                                    "seriesId": 8323,
                                    "seriesName": "Women Central Europe Cup, 2024",
                                    "matchDesc": "6th Match",
                                    "matchFormat": "T20",
                                    "startDate": "1718539200000",
                                    "endDate": "1718551800000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 16, 12:00 GMT",
                                    "team1": {
                                        "teamId": 1987,
                                        "teamName": "Czech Republic Women",
                                        "teamSName": "CZEW",
                                        "imageId": 501075
                                    },
                                    "team2": {
                                        "teamId": 1507,
                                        "teamName": "Gibraltar Women",
                                        "teamSName": "GIBW",
                                        "imageId": 297980
                                    },
                                    "venueInfo": {
                                        "id": 941,
                                        "ground": "Scott Page Field, Vinor",
                                        "city": "Prague",
                                        "timezone": "+02:00",
                                        "latitude": "50.0755",
                                        "longitude": "14.4378"
                                    },
                                    "seriesStartDt": "1718323200000",
                                    "seriesEndDt": "1718668800000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            }
                        ]
                    }
                },
                {
                    "seriesAdWrapper": {
                        "seriesId": 8249,
                        "seriesName": "West Indies Women tour of Sri Lanka, 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96260,
                                    "seriesId": 8249,
                                    "seriesName": "West Indies Women tour of Sri Lanka, 2024",
                                    "matchDesc": "2nd ODI (ICC Championship Match)",
                                    "matchFormat": "ODI",
                                    "startDate": "1718685000000",
                                    "endDate": "1718713800000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 18, 04:30 GMT",
                                    "team1": {
                                        "teamId": 258,
                                        "teamName": "Sri Lanka Women",
                                        "teamSName": "SLW",
                                        "imageId": 172311
                                    },
                                    "team2": {
                                        "teamId": 257,
                                        "teamName": "West Indies Women",
                                        "teamSName": "WIW",
                                        "imageId": 172310
                                    },
                                    "venueInfo": {
                                        "id": 113,
                                        "ground": "Galle International Stadium",
                                        "city": "Galle",
                                        "timezone": "+05:30",
                                        "latitude": "6.031588",
                                        "longitude": "80.216015"
                                    },
                                    "seriesStartDt": "1718409600000",
                                    "seriesEndDt": "1719705600000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96269,
                                    "seriesId": 8249,
                                    "seriesName": "West Indies Women tour of Sri Lanka, 2024",
                                    "matchDesc": "3rd ODI (ICC Championship Match)",
                                    "matchFormat": "T20",
                                    "startDate": "1718944200000",
                                    "endDate": "1718956800000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 21, 04:30 GMT",
                                    "team1": {
                                        "teamId": 258,
                                        "teamName": "Sri Lanka Women",
                                        "teamSName": "SLW",
                                        "imageId": 172311
                                    },
                                    "team2": {
                                        "teamId": 257,
                                        "teamName": "West Indies Women",
                                        "teamSName": "WIW",
                                        "imageId": 172310
                                    },
                                    "venueInfo": {
                                        "id": 113,
                                        "ground": "Galle International Stadium",
                                        "city": "Galle",
                                        "timezone": "+05:30",
                                        "latitude": "6.031588",
                                        "longitude": "80.216015"
                                    },
                                    "seriesStartDt": "1718409600000",
                                    "seriesEndDt": "1719705600000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            }
                        ]
                    }
                },
                {
                    "seriesAdWrapper": {
                        "seriesId": 8314,
                        "seriesName": "Estonia Women tour of Cyprus 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96775,
                                    "seriesId": 8314,
                                    "seriesName": "Estonia Women tour of Cyprus 2024",
                                    "matchDesc": "1st T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718602200000",
                                    "endDate": "1718614800000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 17, 05:30 GMT",
                                    "team1": {
                                        "teamId": 1992,
                                        "teamName": "Cyprus Women",
                                        "teamSName": "CYPW",
                                        "imageId": 174284
                                    },
                                    "team2": {
                                        "teamId": 1521,
                                        "teamName": "Estonia Women",
                                        "teamSName": "ESTW",
                                        "imageId": 315349
                                    },
                                    "venueInfo": {
                                        "id": 1437708,
                                        "ground": "Happy Valley Ground 2",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96780,
                                    "seriesId": 8314,
                                    "seriesName": "Estonia Women tour of Cyprus 2024",
                                    "matchDesc": "2nd T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718629200000",
                                    "endDate": "1718641800000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 17, 13:00 GMT",
                                    "team1": {
                                        "teamId": 1992,
                                        "teamName": "Cyprus Women",
                                        "teamSName": "CYPW",
                                        "imageId": 174284
                                    },
                                    "team2": {
                                        "teamId": 1521,
                                        "teamName": "Estonia Women",
                                        "teamSName": "ESTW",
                                        "imageId": 315349
                                    },
                                    "venueInfo": {
                                        "id": 1437708,
                                        "ground": "Happy Valley Ground 2",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96784,
                                    "seriesId": 8314,
                                    "seriesName": "Estonia Women tour of Cyprus 2024",
                                    "matchDesc": "3rd T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718688600000",
                                    "endDate": "1718701200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 18, 05:30 GMT",
                                    "team1": {
                                        "teamId": 1992,
                                        "teamName": "Cyprus Women",
                                        "teamSName": "CYPW",
                                        "imageId": 174284
                                    },
                                    "team2": {
                                        "teamId": 1521,
                                        "teamName": "Estonia Women",
                                        "teamSName": "ESTW",
                                        "imageId": 315349
                                    },
                                    "venueInfo": {
                                        "id": 1437708,
                                        "ground": "Happy Valley Ground 2",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96789,
                                    "seriesId": 8314,
                                    "seriesName": "Estonia Women tour of Cyprus 2024",
                                    "matchDesc": "4th T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718715600000",
                                    "endDate": "1718728200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 18, 13:00 GMT",
                                    "team1": {
                                        "teamId": 1992,
                                        "teamName": "Cyprus Women",
                                        "teamSName": "CYPW",
                                        "imageId": 174284
                                    },
                                    "team2": {
                                        "teamId": 1521,
                                        "teamName": "Estonia Women",
                                        "teamSName": "ESTW",
                                        "imageId": 315349
                                    },
                                    "venueInfo": {
                                        "id": 1437708,
                                        "ground": "Happy Valley Ground 2",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96798,
                                    "seriesId": 8314,
                                    "seriesName": "Estonia Women tour of Cyprus 2024",
                                    "matchDesc": "5th T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718775000000",
                                    "endDate": "1718787600000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 19, 05:30 GMT",
                                    "team1": {
                                        "teamId": 1992,
                                        "teamName": "Cyprus Women",
                                        "teamSName": "CYPW",
                                        "imageId": 174284
                                    },
                                    "team2": {
                                        "teamId": 1521,
                                        "teamName": "Estonia Women",
                                        "teamSName": "ESTW",
                                        "imageId": 315349
                                    },
                                    "venueInfo": {
                                        "id": 1437708,
                                        "ground": "Happy Valley Ground 2",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96802,
                                    "seriesId": 8314,
                                    "seriesName": "Estonia Women tour of Cyprus 2024",
                                    "matchDesc": "6th T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718802000000",
                                    "endDate": "1718814600000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 19, 13:00 GMT",
                                    "team1": {
                                        "teamId": 1992,
                                        "teamName": "Cyprus Women",
                                        "teamSName": "CYPW",
                                        "imageId": 174284
                                    },
                                    "team2": {
                                        "teamId": 1521,
                                        "teamName": "Estonia Women",
                                        "teamSName": "ESTW",
                                        "imageId": 315349
                                    },
                                    "venueInfo": {
                                        "id": 1437708,
                                        "ground": "Happy Valley Ground 2",
                                        "city": "Episkopi",
                                        "timezone": "+03:00",
                                        "latitude": "34.6741916",
                                        "longitude": "32.8010629"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            }
                        ]
                    }
                },
                {
                    "seriesAdWrapper": {
                        "seriesId": 8229,
                        "seriesName": "Hong Kong Women tour of Netherlands, 2024",
                        "matches": [
                            {
                                "matchInfo": {
                                    "matchId": 96141,
                                    "seriesId": 8229,
                                    "seriesName": "Hong Kong Women tour of Netherlands, 2024",
                                    "matchDesc": "1st T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718625600000",
                                    "endDate": "1718638200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 17, 12:00 GMT",
                                    "team1": {
                                        "teamId": 188,
                                        "teamName": "Netherlands Women",
                                        "teamSName": "NEDW",
                                        "imageId": 172248
                                    },
                                    "team2": {
                                        "teamId": 502,
                                        "teamName": "Hong Kong Women",
                                        "teamSName": "HKW",
                                        "imageId": 172551
                                    },
                                    "venueInfo": {
                                        "id": 529,
                                        "ground": "Sportpark Maarschalkerweerd",
                                        "city": "Utrecht",
                                        "timezone": "+02:00",
                                        "latitude": "52.090737",
                                        "longitude": "5.121420"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96150,
                                    "seriesId": 8229,
                                    "seriesName": "Hong Kong Women tour of Netherlands, 2024",
                                    "matchDesc": "2nd T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718712000000",
                                    "endDate": "1718724600000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 18, 12:00 GMT",
                                    "team1": {
                                        "teamId": 188,
                                        "teamName": "Netherlands Women",
                                        "teamSName": "NEDW",
                                        "imageId": 172248
                                    },
                                    "team2": {
                                        "teamId": 502,
                                        "teamName": "Hong Kong Women",
                                        "teamSName": "HKW",
                                        "imageId": 172551
                                    },
                                    "venueInfo": {
                                        "id": 529,
                                        "ground": "Sportpark Maarschalkerweerd",
                                        "city": "Utrecht",
                                        "timezone": "+02:00",
                                        "latitude": "52.090737",
                                        "longitude": "5.121420"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96159,
                                    "seriesId": 8229,
                                    "seriesName": "Hong Kong Women tour of Netherlands, 2024",
                                    "matchDesc": "3rd T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718787600000",
                                    "endDate": "1718800200000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 19, 09:00 GMT",
                                    "team1": {
                                        "teamId": 188,
                                        "teamName": "Netherlands Women",
                                        "teamSName": "NEDW",
                                        "imageId": 172248
                                    },
                                    "team2": {
                                        "teamId": 502,
                                        "teamName": "Hong Kong Women",
                                        "teamSName": "HKW",
                                        "imageId": 172551
                                    },
                                    "venueInfo": {
                                        "id": 529,
                                        "ground": "Sportpark Maarschalkerweerd",
                                        "city": "Utrecht",
                                        "timezone": "+02:00",
                                        "latitude": "52.090737",
                                        "longitude": "5.121420"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            },
                            {
                                "matchInfo": {
                                    "matchId": 96168,
                                    "seriesId": 8229,
                                    "seriesName": "Hong Kong Women tour of Netherlands, 2024",
                                    "matchDesc": "4th T20I",
                                    "matchFormat": "T20",
                                    "startDate": "1718802000000",
                                    "endDate": "1718814600000",
                                    "state": "Upcoming",
                                    "status": "Match starts at Jun 19, 13:00 GMT",
                                    "team1": {
                                        "teamId": 188,
                                        "teamName": "Netherlands Women",
                                        "teamSName": "NEDW",
                                        "imageId": 172248
                                    },
                                    "team2": {
                                        "teamId": 502,
                                        "teamName": "Hong Kong Women",
                                        "teamSName": "HKW",
                                        "imageId": 172551
                                    },
                                    "venueInfo": {
                                        "id": 529,
                                        "ground": "Sportpark Maarschalkerweerd",
                                        "city": "Utrecht",
                                        "timezone": "+02:00",
                                        "latitude": "52.090737",
                                        "longitude": "5.121420"
                                    },
                                    "seriesStartDt": "1718582400000",
                                    "seriesEndDt": "1718928000000",
                                    "isTimeAnnounced": true,
                                    "stateTitle": "Upcoming Match"
                                }
                            }
                        ]
                    }
                }
            ]
        }
    ],
    "filters": {
        "matchType": [
            "International",
            "League",
            "Domestic",
            "Women"
        ]
    },
    "appIndex": {
        "seoTitle": "Live Cricket Score - Scorecard and Match Results",
        "webURL": "www.cricbuzz.com/live-cricket-scores/"
    },
    "responseLastUpdated": "1718499542"
}
